<template>
  <div class="layout-extended">
    <v-app>
      <v-main>
        <router-view />
      </v-main>
    </v-app>
  </div>
</template>

<script>
import MixinGlobal from "@/mixins";
export default {
  mixins: [MixinGlobal],
};
</script>

<style lang="scss">
@import "../assets/custom";
</style>
